import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-10">
      {/* Gradient Background */}
      <div 
        className="absolute inset-0 opacity-60"
        style={{
          background: `linear-gradient(135deg, #ffe6fe 0%, #fdecff 50%, #dee4d0 100%)`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-12 text-center">
        <div className="space-y-6">
          {/* Brand Badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 text-sm font-medium text-gray-700">
            <div className="w-2 h-2 bg-pink-400 rounded-full animate-pulse" />
            {personalInfo.name} • Personal Brand Strategist
          </div>
          
          {/* Main Heading */}
          <div className="space-y-4">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
              <span className="bg-gradient-to-r from-gray-900 via-pink-800 to-green-800 bg-clip-text text-transparent">
                Turning Ideas Into<br />
                Scroll-stopping Content
              </span>
            </h1>
            
            <div className="space-y-3">
              <h2 className="text-xl md:text-2xl font-light text-gray-700 max-w-4xl mx-auto leading-relaxed">
                Helping brands create content that grabs attention, sparks conversations, and truly connects 
                <span className="text-gray-600">(all with a touch of aesthetic!✨)</span>
              </h2>
            </div>
          </div>
          
          
          {/* Trust Line */}
          <div className="flex items-center justify-center gap-2 pt-6">
            <span className="text-pink-400">✨</span>
            <span className="text-gray-600 text-sm">
              Trusted by brands like <span className="font-semibold">Amazon, Pinterest, Jill Yoga</span>, and more
            </span>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-12">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-gray-900">3+</div>
              <div className="text-sm text-gray-600 mt-1">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-gray-900">500%</div>
              <div className="text-sm text-gray-600 mt-1">Average Growth Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-gray-900">50+</div>
              <div className="text-sm text-gray-600 mt-1">Successful Projects</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Lifestyle Image - Right Side */}
      <div className="absolute right-8 top-1/2 transform -translate-y-1/2 hidden lg:block">
        <div 
          className="w-80 h-96 rounded-2xl overflow-hidden shadow-2xl transform rotate-3 hover:rotate-1 transition-transform duration-300"
          style={{
            background: `linear-gradient(135deg, #ffe6fe 0%, #fdecff 100%)`
          }}
        >
          <div className="p-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/cswzxhlk_DSC07641.jpg" 
              alt="Simm Bedi - Content Creator Lifestyle"
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
        </div>
        
        {/* Floating "Behind the Scenes" badge */}
        <div className="absolute -top-4 -left-4 bg-white rounded-full px-4 py-2 shadow-lg border-2 border-pink-200 transform -rotate-12">
          <span className="text-sm font-medium text-gray-800">✨ BTS Vibes</span>
        </div>
      </div>
      
      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-pink-200 rounded-full opacity-50 animate-bounce" style={{animationDelay: '0s'}} />
      <div className="absolute bottom-40 left-20 w-12 h-12 bg-purple-200 rounded-full opacity-60 animate-bounce" style={{animationDelay: '2s'}} />
    </section>
  );
};

export default Hero;